<label class="form-label">Question Category</label>
<ng-select [readonly]="readonly" class="form-select" [(ngModel)]="selectedCategory" (ngModelChange)="onCategoryChange($event)"
    [ngModelOptions]="{ standalone: true }">
    <ng-option value="" disabled>Select Category</ng-option>
    <ng-option value="">Not Set</ng-option>
    <ng-option *ngFor="let cat of questionCategories" [value]="cat.category">{{cat.category}}</ng-option>
</ng-select>